import { render, staticRenderFns } from "./TypicalProject.vue?vue&type=template&id=746a327e&scoped=true&"
import script from "./TypicalProject.vue?vue&type=script&lang=js&"
export * from "./TypicalProject.vue?vue&type=script&lang=js&"
import style0 from "./TypicalProject.vue?vue&type=style&index=0&id=746a327e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a327e",
  null
  
)

export default component.exports